module.exports = __webpack_public_path__ + "img/maintainMsg.46c933b0.jpg";